<template>
  <div class="content">
    <div class="navBar">
      <div class="navContent">
        <div class="navBarLeft">
          <img
            @click="goback()"
            src="../../../assets/images/common/icon-back.png"
            class="pageBack"
            alt=""
          />
        </div>

        <div class="navBarCenter">
          <span>預覽-商品詳情</span>
          <!--<el-button :type="previewType?'':'primary'" icon="el-icon-mobile" size="mini"-->
          <!--           ></el-button>-->
          <!--<el-button :type="previewType?'primary':''" icon="el-icon-discover" size="mini"-->
          <!--           ></el-button>-->
          <div class="changePreView">
            <div
              class="change-item"
              :class="previewType === 0 ? 'activeLeft' : ''"
              @click="changePreview(0)"
            >
              <img
                src="@/assets/images/preview/phone.png"
                alt=""
                v-show="previewType === 1"
              />
              <img
                src="@/assets/images/preview/phone-select.png"
                alt=""
                v-show="previewType === 0"
              />
            </div>
            <div
              class="change-item"
              :class="previewType === 1 ? 'activeRight' : ''"
              @click="changePreview(1)"
            >
              <img
                src="@/assets/images/preview/pc.png"
                alt=""
                v-show="previewType === 0"
              />
              <img
                src="@/assets/images/preview/pc-select.png"
                alt=""
                v-show="previewType === 1"
              />
            </div>
          </div>
        </div>
        <div class="navBarRight"></div>
      </div>
    </div>
    <div class="browserPreview" v-if="previewType === 1">
      <div class="detail">
        <div class="detail_top">
          <div class="top_imgs">
            <div
              class="imgs_main"
              v-if="mainImg === ''"
              :style="{ backgroundImage: 'url(' + imgFail + ')' }"
              alt=""
            ></div>
            <div
              class="imgs_main"
              v-else
              :style="{ backgroundImage: 'url(' + mainImg + ')' }"
              alt=""
            ></div>
            <div class="imgs_list" v-if="imgList.length === 0">
              <div
                :style="{
                  borderColor: '#EBCE96',
                  backgroundImage: 'url(' + imgFail + ')'
                }"
              ></div>
            </div>
            <div class="imgs_list" v-if="imgList.length !== 0">
              <div
                v-for="(item, index) of imgList"
                :key="index"
                @click="activeImage(index, item.url)"
                :style="{
                  borderColor: index == activeImg ? '#EBCE96' : '',
                  backgroundImage: 'url(' + item.url + ')'
                }"
              ></div>
            </div>
          </div>
          <div class="top_choose">
            <div class="choose_des">
              <h3 class="title">{{ title }}</h3>
              <div class="price" v-if="VIPTWD">
                <span class="price1 newly">{{ TC.label5 }}</span>
                <span class="price2"
                  >{{ VIPTWD | reservePoint
                  }}<em
                    >{{ currency
                    }}{{ $route.query.type === 6 ? TC.label2 : "" }}</em
                  ></span
                >
              </div>
              <div class="price">
                <span class="price1 newly">{{ TC.label1 }}</span>
                <span class="price2"
                  >{{ TWD | reservePoint
                  }}<em
                    >{{ currency
                    }}{{ $route.query.type === 6 ? TC.label2 : "" }}</em
                  ></span
                >
              </div>
            </div>
            <div class="now2020">
              <div class="now2020-3">
                <span class="newly">{{ TC.label3 }}</span>
                <div class="ipts-box">
                  <a>－</a>
                  <input type="text" v-model="skuNum" />
                  <a href="javascript:;">＋</a>
                </div>
              </div>
              <div class="now2020-4">
                <span class="newly">{{ TC.label4 }}</span>
                <ul ref="sizeul">
                  <li v-for="(itema, indexa) of goods" :key="indexa">
                    {{ itema.value }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="buy2020">
              <a href="javascript:;" class="buynow">{{ TC.btnVal3 }}</a>
              <a href="javascript:;" class="addcar">{{ TC.btnVal1 }}</a>
            </div>
            <div class="choose_service">
              <span v-for="(item, index) of service" :key="index"
                ><i></i>{{ item.goodsServicesStr }}</span
              >
            </div>
          </div>
        </div>
        <div class="detail_bottom">
          <div class="bottom_tab">
            <a
              v-for="(item, index) of TC.tabList"
              :key="index"
              @click="activeTab = index"
              :style="{ backgroundColor: activeTab == index ? '#6838DE' : '' }"
              href="javascript:;"
              >{{ item }}</a
            >
          </div>
          <div class="bottom_tabList">
            <div
              class="tabList_detail"
              v-show="activeTab == 0"
              v-html="html"
            ></div>
            <div class="tabList_known" v-show="activeTab == 1">
              <div class="known" v-html="youknow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobilePreview" v-if="previewType === 0">
      <div class="mobile">
        <div class="mobile-bg">
          <div class="content">
            <div class="block-title">
              <span>SHOP</span>
            </div>
            <div class="banner">
              <img src="@/assets/images/preview/banner.jpeg" width="100%" />
            </div>
            <div class="list">
              <div class="list-item">
                <img
                  :src="mainImg == '' ? imgFail : mainImg"
                  alt=""
                  width="100%"
                />
                <p class="good-title">{{ title }}</p>
                <span class="price">{{ TWD }} TWD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div class="mobile-bg">
          <div class="content">
            <div class="head">
              <i class="el-icon-arrow-left block-title"></i>
              <span class="block-title">商品詳情</span>
              <i class="el-icon-shopping-cart-2 block-title"></i>
            </div>
            <div class="good-body">
              <div class="good-img">
                <el-carousel height="230px" indicator-position="outside">
                  <template v-if="mainImg === ''">
                    <img
                      src="@/assets/images/preview/imgFail.jpg"
                      width="90%"
                    />
                  </template>
                  <template v-else>
                    <el-carousel-item
                      v-for="(item, index) in imgList"
                      :key="index"
                    >
                      <img :src="item.url" width="90%" />
                    </el-carousel-item>
                  </template>
                </el-carousel>
              </div>
              <div style="display: flex;align-items: center;">
                <div style="display: flex;align-items: center;" v-if="VIPTWD">
                  <div class="price-vip">{{ TC.label5 }}<span style="font-size: 22px;">{{ VIPTWD }}</span>TWD</div>
                  <div style="margin: 0 5px;color: #7D609A">|</div>
                </div>
                <div class="miprice-tw"><span v-if="VIPTWD">原價</span>{{ TWD }}TWD</div>
              </div>
              <div class="good-title" style="margin-top: 10px;">
                {{ title }}
              </div>
              <div class="good-message">
                <div class="good-attention">
                  <div
                    class="attention-item"
                    v-for="(item, index) in service"
                    :key="index"
                  >
                    <img
                      src="@/assets/images/preview/icon-attention.png"
                      alt=""
                      width="14px"
                    />
                    <span style="word-wrap:break-word">{{
                      item.goodsServicesStr
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="good-sku" @click="showSku = true">
                <div class="sku-choose" @click="showSku = true">
                  <span>選擇 請選擇商品</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="good-detail">
                <div class="line-title">
                  <div class="line"></div>
                  <span>商品詳情</span>
                  <div class="line"></div>
                </div>
                <div v-html="html" style="word-wrap:break-word"></div>
              </div>
              <div class="good-notes">
                <div class="line-title">
                  <div class="line"></div>
                  <span>購買須知</span>
                  <div class="line"></div>
                </div>
                <div v-html="youknow" style="word-wrap:break-word"></div>
              </div>
            </div>
            <div class="footer">
              <div class="footer-btn"><span>加入购物车</span></div>
              <div class="footer-btn"><span>立即購買</span></div>
            </div>
            <div class="sku-detail" v-if="showSku">
              <i class="el-icon-close close" @click="closeSku"></i>
              <div class="choose-item choose-type">
                <span>選擇規格</span>
                <div
                  class="item"
                  v-for="(item, index) in sku"
                  :key="index"
                  :class="index === activeSkuIndex ? 'active' : ''"
                >
                  {{ item.type }}
                </div>
              </div>
              <div class="choose-item choose-num">
                <span>選擇數量</span>
                <div class="num-input">
                  <i class="el-icon-minus icon"></i>
                  <div class="num">
                    <span>{{ skuNum }}</span>
                  </div>
                  <i class="el-icon-plus icon"></i>
                </div>
              </div>
              <div class="footer-btn"><span>確定</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "goodsPreview",
  data() {
    return {
      id: this.$route.query.id,
      previewType: 0, // 預覽類型 0：手機端 1：網頁端
      TC: {
        label1: "價格",
        label2: "起",
        label3: "數量：",
        label4: "規格：",
        label5: "林距離會員價：",
        btnVal1: "加入購物車",
        btnVal2: "商品已售完",
        btnVal3: "立即購買",
        btnVal4: "售賣",
        msgTitle: "提示",
        msgText1: "請先登入",
        msgBtnVal1: "去認證",
        msgBtnVal2: "重新認證",
        msgBtnVal3: "我知道了",
        msgBtnVal4: "登入",
        tabList: ["商品介紹", "購買須知"],
        prompt1: ":",
        prompt2: ":",
        prompt3: ":",
        prompt5: "該商品已售完",
        prompt6: "請選擇規格",
        prompt7: "所選商品庫存不足",
        prompt8: "已加入購物車",
        addPrompt1: "失敗原因："
      },
      //大图
      imgFail: require("@/assets/images/preview/imgFail.jpg"),
      mainImg: "",
      title: "",
      TWD: "",
      VIPTWD: "",
      currency: "TWD",
      des: "",
      //小图列表
      imgList: [],
      //激活选择图片
      activeImg: 0,
      //2020页面合并
      //入会礼模块
      goods: [],
      //购买限制
      limit: [],
      buyLimit: "",
      //输入框数量
      amount: [],
      //选择的时候样式
      active: [],
      active1: [],
      active2: [],
      //勾选状态
      checkArr: [],
      //提交的组合
      subArr: [],
      //监控选择数量
      nodes: [],
      //商品类型
      vipGoods: false,
      //售卖状态
      saleState: 0,
      //单规格商品的
      attrName: "",
      saleTime: "",
      countdown: "00天00小时00分00秒",
      //tab激活
      activeTab: 0,
      //币值及币种
      /*othercurrencyPrice: null,
      othercurrency: null,*/
      //连点
      clicktag: 0,
      //详情图
      html: "",
      // 服务文本
      service: [],
      //购买须知
      youknow: "",
      timer2: null,
      saleId: "",
      showSku: false,
      sku: [],
      activeSkuIndex: 0,
      skuNum: 1,
      minActive: true,
      addActive: false
    };
  },
  created() {
    this.initContent();
  },
  methods: {
    initContent() {
      let _this = this;
      _this
        .$post(
          `/request/mall/queryGoodsDetails?goodsId=${_this.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            var good = res.data;
            let skuRequestList = good[0].skuRequestList;
            _this.title = good[0].goodsName;
            _this.mainImg = good[0].imgUrl;
            if (skuRequestList) {
              _this.TWD =
                skuRequestList.length > 0 ? skuRequestList[0].realPrice : 0;
              _this.VIPTWD =
                skuRequestList.length > 0 && skuRequestList[0].vipRealPrice
                  ? skuRequestList[0].vipRealPrice
                  : "";
            } else {
              _this.TWD = good[0].skuRequest.realPrice;
              _this.VIPTWD = good[0].skuRequest.vipRealPrice
                ? good[0].skuRequest.vipRealPrice
                : "";
            }

            _this.vipGoods = good[0].goodsTerm === 1;
            for (let i in res.data[0].accessoryDto.imgUrl) {
              _this.imgList.push({
                name: "img.jpg",
                url: res.data[0].accessoryDto.imgUrl[i].imgUrlStr
              });
            }
            // 商品服务
            this.service = res.data[0].accessoryDto.goodsServicesList;
            console.log(this.service);

            // 购买须知
            // for (let k in res.data[0].accessoryDto.purchaseNotesDtoList) {
            //   this.youknow =
            //     this.youknow +
            //     res.data[0].accessoryDto.purchaseNotesDtoList[k].mainDody;
            // }
            this.youknow = res.data[0].accessoryDto.purchaseNotesDtoList[0].mainDody.replace(
              /<img(.*?)>/g,
              '<img\$1 style="width: 100%;" />'
            );

            // 商品介紹
            _this.html = res.data[0].accessoryDto.graphicDetails.replace(
              /<img(.*?)>/g,
              '<img\$1 style="width: 100%;" />'
            );

            // for (let obj of good[0].goodsAttachList) {
            //   if (obj.type == 1) {
            //     _this.imgList.push({name: 'img.jpg', url: obj.fileUrl})
            //   } else if (obj.type == 2) {
            //     _this.html = obj.fileUrl
            //   } else if (obj.type == 4) {
            //     _this.service.push(obj.fileUrl)
            //   } else if (obj.type == 5) {
            //     _this.youknow = obj.fileUrl
            //   }
            // }

            for (let good of res.data[0].skuRequestList) {
              this.sku.push({ type: good.value, num: Number(good.realTotal) });
              this.limit.push(Number(good.realTotal));
              this.goods.push(good);
              this.amount.push(1);
            }
            this.buyLimit = good[0].buyMaxNum;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    goback() {
      let _this = this;
      _this.$router.go(-1);
    },
    changePreview(val) {
      this.previewType = val;
    },
    activeImage(index, url) {
      this.activeImg = index;
      this.mainImg = url;
    },
    closeSku() {
      this.showSku = false;
    },
    minSku() {
      if (this.skuNum === 0) {
        this.skuNum = 0;
        this.minActive = true;
        this.addActive = false;
      } else {
        this.skuNum--;
        if (this.skuNum === 0) {
          this.minActive = true;
        } else {
          this.minActive = false;
        }
        this.addActive = false;
      }
    },
    addSku(maxNum) {
      if (this.skuNum + 1 <= maxNum && this.skuNum + 1 <= this.buyLimit) {
        this.skuNum++;
        if (this.skuNum === maxNum || this.skuNum === this.buyLimit) {
          this.addActive = true;
          console.log(this.addActive);
        } else {
          this.addActive = false;
        }
        this.minActive = false;
      } else {
        this.addActive = true;
      }
    }
  },
  filters: {
    //保留2位小数 四舍五入
    reservePoint(reservePoint) {
      return parseFloat(reservePoint).toFixed(2);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setListType", 1);

    if (to.name === "goodsList") {
      next();
    } else {
      this.$router.push("/goodsList");
    }
  }
};
</script>

<style lang="less" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.navBar {
  height: 0.8rem;
  padding: 0.2rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  z-index: 100;
  background: #fafafd;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    // top: 0.8rem;
  }
  @media (min-width: 769px) {
    width: calc(100% - 2.2rem);
  }

  .navContent {
    width: calc(100% - 1.08rem);
    height: 100%;
    display: flex;
    justify-content: space-between;

    .navBarLeft {
      padding-left: 1rem;
      line-height: 0.4rem;
      color: #292929;
      display: inline-block;

      .pageBack {
        margin-right: 20px;
        width: 14px;
      }
    }

    .navBarCenter {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        color: #292929;
        font-size: 20px;
        margin-right: 10px;
      }

      .changePreView {
        display: inline-block;
        width: 122px;
        height: 42px;
        background-color: #f5f5f8;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;

        .change-item {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .activeLeft {
          background-color: #e0e0e0;
          border-top-left-radius: 100px;
          border-bottom-left-radius: 100px;
        }

        .activeRight {
          background-color: #e0e0e0;
          border-bottom-right-radius: 100px;
          border-top-right-radius: 100px;
        }
      }
    }
  }
}

.mobilePreview {
  height: 100vh;
  width: 100%;
  padding: 1.1rem 0 0.3rem 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .mobile {
    width: 375px;
    height: 716px;
    margin-left: 60px;
    margin-right: 60px;

    .mobile-bg {
      width: 100%;
      height: 100%;
      position: relative;
      background: url("../../../assets/images/preview/iphone-border.png")
        no-repeat;
      background-size: cover;

      .content {
        width: 370px;
        height: 716px;
        padding: 55px 32px 135px 32px;
        border-radius: 55px;
        margin-left: 2px;

        .head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12.5px;
        }

        .good-body {
          width: 100%;
          height: 100%;
          overflow: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;

          .good-img {
            width: 100%;
            height: 300px;
            margin-top: 12.5px;
            margin-bottom: 28px;
            background-color: #22242e;
            border-radius: 10px;
            padding: 25px 15px 20px 15px;
          }

          .good-title {
            text-align: left;
            color: #ffffff;
            font-size: 14px;
            margin-bottom: 45px;
            word-wrap: break-word;
          }

          .good-message {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .good-attention {
              .attention-item {
                display: flex;
                align-items: center;
                margin-bottom: 14.5px;

                span {
                  color: #8c8d91;
                  font-size: 12px;
                  margin-left: 5.5px;
                }
              }
            }

            .good-price {
              .price-tw {
                color: #6b31fe;
                font-size: 22px;
              }

              .price-rmb {
                color: #8f7e60;
                font-size: 14px;
              }
            }
          }

          .good-sku {
            padding: 18px 11px;
            background-color: #22242e;
            border-radius: 10px;
            margin-top: 32.5px;
            cursor: pointer;

            .sku-choose {
              display: flex;
              justify-content: space-between;
              align-items: center;
              color: #8a8a8d;
              cursor: pointer;
            }
          }

          .good-detail {
            color: #ffffff;
            text-align: left;
          }

          .good-notes {
            color: #ffffff;
            text-align: left;
          }

          .line-title {
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin: 30px 0;

            .line {
              height: 1px;
              width: 80px;
              background-color: #33333b;
              display: inline-block;
            }

            span {
              color: #ebebeb;
              font-size: 14px;
            }
          }
        }

        .good-body::-webkit-scrollbar {
          display: none;
        }

        .footer {
          width: 322px;
          height: 80px;
          position: absolute;
          left: 26px;
          bottom: 19px;
          border-bottom-left-radius: 35px;
          border-bottom-right-radius: 35px;
          background-color: #181a22;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;

          .footer-btn {
            height: 40px;
            flex: 1;
            border-radius: 22.5px;
            background: linear-gradient(90deg, #8545fe, #6c31fe);
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              color: #ffffff;
              font-size: 16px;
            }
          }

          .footer-btn:first-child {
            margin-right: 22px;
          }
        }

        .sku-detail {
          width: 322px;
          height: 450px;
          position: absolute;
          left: 26px;
          bottom: 19px;
          border-radius: 20px 20px 35px 35px;
          background-color: #181a22;
          padding: 70px 30px 0 30px;
          z-index: 100;
          text-align: left;

          .close {
            color: #a7a8ab;
            font-size: 16px;
            cursor: pointer;
            position: absolute;
            top: 15.5px;
            right: 12.5px;
          }

          .choose-item {
            margin-bottom: 25px;

            span {
              color: #ffffff;
              font-size: 14px;
              display: block;
              margin-bottom: 25px;
            }
          }

          .choose-type {
            .item {
              display: inline-block;
              width: 54.5px;
              height: 29.5px;
              line-height: 29.5px;
              text-align: center;
              border-radius: 14.76px;
              background-color: #303139;
              box-sizing: border-box;
              font-size: 12px;
              color: #ffffff;
              margin-right: 10px;
              cursor: pointer;
            }

            .active {
              border: 0.5px solid #6b31fe;
              background-color: transparent;
              color: #6b31fe;
            }

            .inactive {
              border: 0.5px dotted #525258;
              background-color: #303139;
              color: #48494e;
            }
          }

          .choose-num {
            .num-input {
              width: 94.5px;
              height: 29.5px;
              border-radius: 14.75px;
              background-color: #303139;
              display: flex;
              justify-content: space-around;
              align-items: center;

              i {
                cursor: pointer;
              }

              .num {
                width: 27px;
                height: 27px;
                display: inline-block;
                border-radius: 14.75px;
                background: linear-gradient(90deg, #a15bff, #6b31fe);
                text-align: center;
                line-height: 27px;

                span {
                  color: #ffffff;
                  font-size: 14px;
                }
              }

              .icon {
                font-size: 16px;
                color: #ffffff;
              }

              .inactive {
                color: #4a4b50;
              }
            }
          }

          .footer-btn {
            position: absolute;
            bottom: 22.5px;
            left: 50%;
            transform: translate(-50%);
            width: 80%;
            height: 40px;
            border-radius: 22.5px;
            background: linear-gradient(90deg, #8545fe, #6c31fe);
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              color: #ffffff;
              font-size: 16px;
            }
          }
        }

        .block-title {
          font-size: 16px;
          color: #ffffff;
        }

        .banner {
          margin-top: 13px;
          margin-bottom: 13px;
        }

        .list {
          width: 100%;
          display: flex;

          .list-item {
            width: 50%;
            min-height: 255px;
            background-color: #24242e;
            border-radius: 10px;
            padding: 25px 12.5px 0 12.5px;

            .good-title {
              color: #ffffff;
              font-size: 14px;
              margin-top: 20px;
              margin-bottom: 10px;
              word-wrap: break-word;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .price {
              color: #7035fe;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

.browserPreview {
  min-height: 100vh;
  width: 100%;
  min-width: 960px;
  background-color: #1a1a24;
  padding: 110px 0 30px 0;
  text-align: left;
  color: #ffffff;

  .detail {
    width: 65%;
    min-width: 960px;
    height: 100%;
    background-color: #29293a;
    margin: 0 auto;
    border-radius: 4px;
    padding: 63px 43px 43px 43px;

    .detail_top {
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      .top_imgs {
        .imgs_main {
          width: 340px;
          height: 340px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          margin-bottom: 20px;
          border-radius: 4px;
        }

        .imgs_list {
          display: flex;

          div {
            border: 0.01rem solid rgba(0, 0, 0, 0);
            border-radius: 4px;
            overflow: hidden;
            width: 18.4%;
            padding-top: 18.4%;
            margin-right: 2%;
            cursor: pointer;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }

          div:last-child {
            margin-right: 0;
          }
        }
      }

      .top_choose {
        flex: 1;
        padding-bottom: 0.4rem;

        .outside {
          width: 0.22rem;
          height: 0.22rem;
          border-radius: 50%;
          cursor: pointer;
          // overflow: hidden;
          .inside {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: url("https://start.sanctuarytech.co/dist/images/check.png")
              no-repeat center;
            background-size: 72% 72%;
            background-color: #6838de;
          }
        }

        .newly {
          min-width: 1.1rem;
          font-size: 0.16rem;
          color: rgba(255, 255, 255, 0.6);
          margin-right: 0.1rem;
        }

        margin-left: 0.38rem;

        .choose_des {
          .title {
            font-size: 0.22rem;
            color: #fff;
            margin: 0.2rem 0 0.1rem;
            word-wrap: break-word;
          }

          .limit {
            font-size: 0.18rem;
            color: rgba(255, 255, 255, 1);
          }

          .price {
            margin-top: 0.2rem;
            display: flex;
            height: 0.5rem;
            align-items: center;
            width: 76%;
            // background: -ms-linear-gradient( rgba(253, 224, 169, 0.2),rgba(253, 224, 169, 0));
            // background: -webkit-gradient(linear, left top , left bottom, from(rgba(253, 224, 169, 0.2)), to(rgba(253, 224, 169, 0)));
            .price1 {
              margin-right: 0;
            }

            .price2 {
              font-size: 0.32rem;
              font-weight: 700;
              color: #6838de;

              em {
                font-size: 0.18rem;
              }

              b {
                font-size: 0.18rem;
                color: #ebce96;
                margin-left: 0.1rem;
              }
            }
          }
        }

        .now2020 {
          margin-top: 0.4rem;
          padding-bottom: 0.4rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          position: relative;

          .mask2020 {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(41, 41, 58, 0.6);
          }

          .now2020-1 {
            width: 76%;
            display: flex;
            align-items: center;

            p {
              flex: 1;
              display: flex;
              justify-content: space-between;
              font-size: 0.2rem;
              color: #fff;
            }
          }

          .now2020-2 {
            display: flex;
            align-items: center;
            margin-top: 0.3rem;

            .span1 {
              font-size: 0.2rem;
              color: #fff;
            }
          }

          .now2020-3 {
            margin-top: 0.3rem;
            display: flex;
            align-items: center;
            margin-bottom: 0.3rem;

            .ipts-box {
              display: flex;

              a {
                width: 0.4rem;
                height: 0.4rem;
                border-radius: 2px;
                border: 0.02rem solid rgba(255, 255, 255, 0.6);
                font-size: 0.18rem;
                color: #fff;
                line-height: 0.38rem;
                text-align: center;
              }

              input {
                width: 0.6rem;
                height: 0.4rem;
                border-radius: 2px;
                border: 0.02rem solid rgba(255, 255, 255, 0.6);
                font-size: 0.18rem;
                color: rgba(41, 41, 58, 0.6);
                text-align: center;
                margin: 0 0.08rem;
              }
            }
          }

          .now2020-4 {
            display: flex;
            margin-bottom: 0.1rem;

            span {
              padding-top: 0.1rem;
            }

            ul {
              display: flex;
              flex-wrap: wrap;

              li {
                line-height: 0.4rem;
                text-align: center;
                padding: 0 0.2rem;
                height: 0.44rem;
                box-sizing: border-box;
                border: 0.02rem solid rgba(255, 255, 255, 0.6);
                border-radius: 4px;
                background: none;
                color: #fff;
                cursor: pointer;
                font-size: 0.16rem;
                margin-right: 0.16rem;
                margin-bottom: 0.2rem;
              }

              .addclass {
                background: url("https://start.sanctuarytech.co/dist/images/dress_border.png")
                  no-repeat right -0.02rem bottom -0.02rem;
                border-color: #6838de;
                background-size: 0.25rem 0.22rem;
              }
            }
          }
        }

        .buy2020 {
          display: flex;
          margin-top: 0.3rem;

          a {
            height: 0.5rem;
            font-size: 0.18rem;
            color: #fff;
            line-height: 0.5rem;
            text-align: center;
            border-radius: 4px;
          }

          .buynow {
            background: #6838de;
            padding: 0 0.4rem;
            margin-right: 0.3rem;
          }

          .buywait {
            background: #999;
            padding: 0 0.4rem;
            margin-right: 0.3rem;
          }

          .saled {
            background: #999;
            padding: 0 0.4rem;
            margin-right: 0.3rem;
          }

          .addcar {
            line-height: 0.46rem;
            padding: 0 0.2rem;
            border: 0.02rem solid rgba(255, 255, 255, 0.5);
          }
        }

        .choose_service {
          margin-top: 0.3rem;

          span {
            font-size: 0.16rem;
            color: #fff;
          }

          i {
            display: inline-block;
            width: 0.16rem;
            height: 0.16rem;
            background: url("https://start.sanctuarytech.co/dist/images/warning.png")
              no-repeat center;
            background-size: 96% 96%;
            vertical-align: middle;
            margin: 0 0.04rem 0 0.12rem;
          }
        }
      }
    }

    .detail_bottom {
      padding-top: 0.4rem;

      .bottom_tab {
        background: #3f3f4e;
        border-bottom: 0.01rem solid #6838de;

        a {
          display: inline-block;
          height: 0.5rem;
          font-size: 0.18rem;
          line-height: 0.5rem;
          color: rgba(255, 255, 255, 1);
          padding: 0 0.15rem;
        }
      }

      .bottom_tabList {
        padding: 0 20%;
        margin-top: 0.3rem;
        min-height: 4rem;

        .tabList_detail {
          margin: 0 auto;
          div {
            width: ;
            img {
              width: 100%;
            }
          }
        }

        .tabList_known {
          .known {
            margin-bottom: 0.3rem;

            h3 {
              font-size: 0.18rem;
              color: #ebce96;
              line-height: 0.3rem;
            }

            p {
              font-size: 0.16rem;
              color: #fff;
              line-height: 0.3rem;
              img {
                width: 300px;
              }
            }
          }
        }
      }

      .mbsubmit {
        display: none;
      }
    }
  }
}
</style>
<style>
.good-detail img,
.good-notes img {
  width: 100%;
}
.miprice-tw{
  font-size: 14px;
  color: #7D609A;
  margin-top: 5px;
}
.price-vip{
  color: #CBAB65;
  font-weight: bold;
  font-size: 14px
}
</style>



// WEBPACK FOOTER //
// src/pages/market/marketGoods/goodsPreview.vue